import styled from 'styled-components/macro';
import { IHeadingsProps } from './header.types';
import { device } from '../../../../../styles/device';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-gap: 10px;
  margin-bottom: 30px;
  padding: ${({ theme }) => theme.layout.pagePadding};

  @media ${device.tablet} {
    grid-template-columns: auto auto;
  }

  .headerLabel {
    margin-top: 10px;
    @media ${device.tablet} {
      margin-top: 15px;
    }
  }

  @media ${device.laptopL} {
    padding: 0;
  }
`;

export const HeadingsItem = styled.li`
  display: grid;
  grid-template-rows: auto auto;
  grid-gap: 15px;

  h2 {
    @media ${device.tablet} {
      padding-right: 15px;
    }
  }
`;

export const Headings = styled.ul<IHeadingsProps>`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: ${({ align }) =>
    align === 'right' ? 'auto auto auto' : 'auto'};

  ${HeadingsItem} {
    &:first-child {
      text-align: left;
      @media (min-width: 900px) {
        ${({ align }) => align === 'right' && 'text-align: right'};
      }
    }
    &:nth-child(2) {
      text-align: center;
      @media (min-width: 900px) {
        ${({ align }) => align === 'right' && 'text-align: right'};
      }
    }

    &:last-child {
      ${({ align }) => align === 'right' && 'text-align: right'};
    }
  }
`;
